import { render, staticRenderFns } from "./taskBoard.vue?vue&type=template&id=3a8d9222&scoped=true"
import script from "./taskBoard.vue?vue&type=script&lang=js"
export * from "./taskBoard.vue?vue&type=script&lang=js"
import style0 from "./taskBoard.vue?vue&type=style&index=0&id=3a8d9222&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8d9222",
  null
  
)

export default component.exports